import { PROVINCES_LIST } from "../constants/api-path";
import httpClient from "./http.interceptor";

/**
 * @param {page: number, limit: number, sortColumn: string|number, sortDirection: string } formData
 * @returns Promise<any>
 */
export const getAppProvinces = (formData: any): Promise<any> => {
  return httpClient.get(PROVINCES_LIST, {
    params: {
      page: formData.page,
      pageSize: formData.limit,
      sort: formData.sort,
      search: formData.search,
      country_id: formData.country_id,
    },
  });
};
